import DataTable from "datatables.net-bs5";
import 'datatables.net-select-bs5'
import $ from "jquery";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";

export function initDataTableSelector(selector) {
    window[selector] = new DataTable($(`#${selector}`), {
        processing: true,
        serverSide: false,
        scrollCollapse: true,
        layout: {
            topStart: 'search',
            topEnd: null
        },
        scroller: {
            loadingIndicator: false
        },
        scrollY: 'calc(100vh - 310px)',
        deferRender: true,
        autoWidth: false,
        fixedColumns: true,
        fixedHeader: true,
        scrollX: true,
        searching: true,
        initComplete: () => {
            getBySelector(`#${selector}_filter`).parentElement.classList.remove('col-md-6')
            getBySelector(`#${selector}_info`).parentElement.classList.remove('col-md-5')

            if(!window.chrome) {
                const search = document.querySelector(`#${selector}_filter input`)
                if (search) {
                    search.addEventListener('keyup', () => {
                        if (search.value) {
                            showElementsBySelector(`#${selector}_clear`)
                        } else {
                            hideElementsBySelector(`#${selector}_clear`)
                        }
                    })
                }
            }
        },
        language: {
            "sProcessing": "",
            "sLengthMenu": "_MENU_ resultaten weergeven",
            "sZeroRecords": "Geen resultaten gevonden",
            "sInfo": "_START_ tot _END_ van _TOTAL_ resultaten",
            // "sInfo": "Er zijn _TOTAL_ resultaten",
            "sInfoEmpty": "Geen resultaten om weer te geven",
            // "sInfoEmpty": "Geen resultaten om weer te geven",
            "sInfoFiltered": " (gefilterd uit _MAX_ resultaten)",
            "sInfoPostFix": "",
            "sSearch": "Zoeken:",
            "sEmptyTable": "Geen resultaten aanwezig in de tabel",
            "sInfoThousands": ".",
            "sLoadingRecords": "Een moment geduld aub - bezig met laden...",
            "oPaginate": {
                "sFirst": "Eerste",
                "sLast": "Laatste",
                "sNext": "Volgende",
                "sPrevious": "Vorige"
            },
            "oAria": {
                "sSortAscending": ": activeer om kolom oplopend te sorteren",
                "sSortDescending": ": activeer om kolom aflopend te sorteren"
            },
            select: {
                rows: {
                    _: "",
                    0: "",
                    1: ""
                    // _: "%d items geselecteerd",
                    // 0: "Klik op een item om het te selecteren",
                    // 1: "1 item geselecteerd"
                }
            }
        }
    });
}
